import { Reveal } from "./Reveal";

// ---------------------------------------------------------------------------
// PROCESS — "De la primera llamada a funcionando: 10 días."
// ---------------------------------------------------------------------------

const steps = [
  {
    time: "DÍA 0",
    dot: "#A78BFA",
    title: "Llamada de demo (20 min)",
    body: "Es una llamada de venta, no te vamos a hacer el verso. Te mostramos cuentas en vivo de clientes y te decimos si CreceLocal sirve para tu negocio.",
  },
  {
    time: "DÍA 1",
    dot: "#A78BFA",
    title: "Completás un formulario simple",
    body: "Los detalles de tu negocio: rubro, servicios, precios, tono. Con la información correcta nos ponemos a trabajar.",
  },
  {
    time: "DÍA 7-10",
    dot: "#E879F9",
    title: "Armamos tu sistema",
    body: "Construimos tu sitio web, tu ficha de Google, el inbox, el Agente IA y los seguimientos. Vos no tocás nada.",
  },
  {
    time: "ENTREGA",
    dot: "#34D399",
    title: "Llamada de entrega (25 min)",
    body: "Te mostramos todo funcionando. Y por todo nos referimos a apretar dos botones. De ahí en más: soporte por WhatsApp con gente real.",
  },
];

export function HomeProcess() {
  return (
    <section
      data-screen-label="Proceso"
      id="proceso"
      className="bg-[#0F0D14] border-t border-b border-[#221F2A] scroll-mt-16"
    >
      <div
        className="mx-auto px-6"
        style={{
          maxWidth: 1240,
          paddingTop: "clamp(80px,10vw,128px)",
          paddingBottom: "clamp(80px,10vw,128px)",
        }}
      >
        <Reveal>
          <div
            className="font-mono text-[13px] text-[#A78BFA]"
            style={{ letterSpacing: "0.08em" }}
          >
            08 — CÓMO TRABAJAMOS
          </div>
          <h2
            className="mt-5 text-[#EEEDF2] font-medium"
            style={{
              fontSize: "clamp(36px,4.8vw,64px)",
              lineHeight: 1.02,
              letterSpacing: "-0.025em",
              textWrap: "balance" as never,
            }}
          >
            De la primera llamada a funcionando:{" "}
            <span className="text-[#A78BFA] italic">10 días.</span>
          </h2>
        </Reveal>

        <div
          className="relative grid gap-5 mt-16"
          style={{ gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))" }}
        >
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div className="relative pt-7 border-t border-[#2E2A38]">
                <div
                  className="absolute rounded-full"
                  style={{
                    top: -6,
                    left: 0,
                    width: 11,
                    height: 11,
                    background: s.dot,
                    boxShadow: "0 0 0 4px #0F0D14",
                  }}
                />
                <div
                  className="font-mono text-[12px] text-[#A78BFA]"
                  style={{ letterSpacing: "0.05em" }}
                >
                  {s.time}
                </div>
                <h3 className="text-[21px] font-semibold mt-3 tracking-[-0.01em] text-[#EEEDF2]">
                  {s.title}
                </h3>
                <p
                  className="text-[#9C98A6] leading-[1.55] mt-2.5"
                  style={{ textWrap: "pretty" as never }}
                >
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
